import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 pt-3 border-t border-[#f1f5f9] sm:flex-row sm:items-center sm:justify-between text-xs" }
const _hoisted_2 = { class: "text-[#64748b] font-medium" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "px-1 text-[#94a3b8]"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["disabled"]

import { computed } from "vue";
import { ChevronLeft, ChevronRight } from "lucide-vue-next";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportPagination',
  props: {
    currentPage: {},
    totalPages: {},
    totalItems: {},
    pageSize: {}
  },
  emits: ["update:current-page"],
  setup(__props: any) {

const props = __props;



const startItem = computed(() => {
  if (props.totalItems === 0) return 0;
  return (props.currentPage - 1) * props.pageSize + 1;
});

const endItem = computed(() => {
  if (props.totalItems === 0) return 0;
  return Math.min(props.currentPage * props.pageSize, props.totalItems);
});

const visiblePages = computed<(number | string)[]>(() => {
  const total = props.totalPages;
  const current = props.currentPage;

  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  if (current <= 3) {
    return [1, 2, 3, "...", total];
  }

  if (current >= total - 2) {
    return [1, "...", total - 2, total - 1, total];
  }

  return [1, "...", current, "...", total];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(startItem.value) + "-" + _toDisplayString(endItem.value) + " of " + _toDisplayString(__props.totalItems) + " clients ", 1),
    (__props.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "page-nav-btn",
            disabled: __props.currentPage === 1,
            title: "Previous page",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:current-page', __props.currentPage - 1)))
          }, [
            _createVNode(_unref(ChevronLeft), { class: "h-3.5 w-3.5" })
          ], 8, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (item, idx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
              (item === '...')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ... "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: _normalizeClass(["page-num-btn", item === __props.currentPage ? 'page-num-btn--active' : '']),
                    onClick: ($event: any) => (_ctx.$emit('update:current-page', Number(item)))
                  }, _toDisplayString(item), 11, _hoisted_6))
            ], 64))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            class: "page-nav-btn",
            disabled: __props.currentPage === __props.totalPages,
            title: "Next page",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:current-page', __props.currentPage + 1)))
          }, [
            _createVNode(_unref(ChevronRight), { class: "h-3.5 w-3.5" })
          ], 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})